module.exports = __webpack_public_path__ + "img/pine_kids_logo.68bd6c5b.png";